'use client';

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ApiConfigration } from '@/hotdesk-ui/common-classes/api-configuration';
import { RootState } from '../store';

export interface WorkspaceCategoryItem {
    id: number;
    category: string;
}

interface WorkspaceCategoriesState {
    items: WorkspaceCategoryItem[];
    loading: boolean;
    error: string | null;
}

const initialState: WorkspaceCategoriesState = {
    items: [],
    loading: false,
    error: null
};

export const fetchWorkspaceCategories = createAsyncThunk(
    'workspaceCategories/fetch',
    async (_, { getState }) => {
        const state = getState() as RootState;
        const { defaultLanguage } = state.listing;
        const apiConfig = await new ApiConfigration().getApiConfig(defaultLanguage);
        const { WorkspaceCategoryApi } = await import('hotdesk_typescript');
        const api = new WorkspaceCategoryApi(apiConfig);
        const res = await api.workspaceCategoryList({ limit: 20 });
        const results = (res as any)?.results || [];
        return results.map((c: any) => ({ id: c.id, category: c.category }));
    }
);

const workspaceCategoriesSlice = createSlice({
    name: 'workspaceCategories',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchWorkspaceCategories.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchWorkspaceCategories.fulfilled, (state, action) => {
                state.items = action.payload;
                state.loading = false;
            })
            .addCase(fetchWorkspaceCategories.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'Failed to fetch workspace categories';
            });
    }
});

export default workspaceCategoriesSlice.reducer;
